export const initialState = {
    rjList: null,
    activeRj:null
  };